import { render } from "./Domicilio.vue?vue&type=template&id=878f7ea6&scoped=true"
import script from "./Domicilio.vue?vue&type=script&lang=js"
export * from "./Domicilio.vue?vue&type=script&lang=js"

import "./Domicilio.vue?vue&type=style&index=0&id=878f7ea6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878f7ea6"]])

export default __exports__